import { render, staticRenderFns } from "./DetectionWriteLink.vue?vue&type=template&id=65bfee8e&scoped=true"
import script from "./DetectionWriteLink.vue?vue&type=script&lang=js"
export * from "./DetectionWriteLink.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65bfee8e",
  null
  
)

export default component.exports